/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import { connect } from 'react-redux';
import invariant from 'invariant';
import LoadingIndicator from 'edrolo/domains/app/components/LoadingIndicator';
import { actions as classActions } from 'edrolo/reducers/class';
import createClassSelectors from 'edrolo/selectors/bound/createClassSelectors';

const mapStateToProps = (state, ownProps) => {
  const classId = ownProps.match.params?.classId;
  const classSelectors = createClassSelectors(classId);
  return {
    classId,
    classDetail: classSelectors.getClassDetail(state),
    enrolmentProfiles: classSelectors.getClassEnrolmentProfiles(state),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  loadClassDetail: () =>
    dispatch(
      classActions.loadClassDetail.signal(ownProps?.match?.params?.classId)
    ),
});

export default function classDetailLoader(WrappedComponent) {
  class ClassDetailLoader extends Component {
    componentDidMount() {
      invariant(
        this.props.classId,
        'classDetailLoader only works with classId in props or :classId as a route parameter'
      );

      if (!this.props.classDetail) {
        global.ifDev(`loading class detail (class:${this.props.classId})`);
        this.props.loadClassDetail();
      }
    }

    render() {
      return !this.props.classDetail ? (
        <LoadingIndicator loadingText={'Loading Class Detail'}>
          <WrappedComponent {...this.props} />
        </LoadingIndicator>
      ) : (
        <WrappedComponent {...this.props} />
      );
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)(ClassDetailLoader);
}
